import PalletBuilderSuperStore from "../../stores/PalletBuilderSuperStore";

export const BuildPalletMachineConfig =
    {
        services: {
            getCurrentAndLastPallet: ctx => new PalletBuilderSuperStore().getCurrentAndLastPallet(),
            cancelCurrentPallet: ctx => new PalletBuilderSuperStore().cancelPallet(ctx.pallet),
            startPallet: ctx => new PalletBuilderSuperStore().startPallet(ctx.startPalletData),
            finishPallet: ctx => new PalletBuilderSuperStore().finishPallet(ctx.finishPalletData),
            printManifest: ctx => new PalletBuilderSuperStore().printManifest(ctx.pallet.id, ctx.finishPalletData.stationId, ctx.finishPalletData.saveDesignerData),
        },
        actions: {
            // action implementations
            startPallet: (context, event) => {
                console.log('Starting pallet...');
            },
            showStatusPrintingStart: (context, event) => {
                const msg = "Generating Manifest";
                context.status = msg;
                console.log(msg);
            },
            clearStatus: (context, event) => {
                context.status = null;
                context.events = [];
                console.log("Cleared status");
            },
            refreshPallet: async (context, event) => {
                console.log('Refreshing pallet...');
                const refreshed = await new PalletBuilderSuperStore().getCurrentAndLastPallet();
                context.pallet = refreshed.pallet;
                context.lastPallet = refreshed.lastPallet;
                context.lastRefreshed = new Date();
            },
            finishPallet: async (context, event) => {
                console.log('Finishing pallet!');
                context.events.push('Saving pallet');
                await new PalletBuilderSuperStore().finishPallet(event.formData);
            },
            checkInOperator: async (context, event) => {
                console.log('Checking In Operator', {event});
                context.events.push('Checking in operator');
                await new PalletBuilderSuperStore().checkInOperatorAtSite(event.personId);
            },
            logError: (context, event) => {
                console.error(event);
                context.error = event;
            },
        }
    }

export default BuildPalletMachineConfig;

